// extracted by css-extract-rspack-plugin
module.exports =  {"content":"ContentLoading__content___FUupZ","compact":"ContentLoading__compact___izicI"};